import { useEffect, useMemo, useState } from 'react';
import { Text } from '~/components/ui/Text';
import { ICharacterSkillLevel, rage } from '~/rage';
import { CharacterSkill } from '~/shared';
import { StatsSkillItem } from '../StatsSkillItem';
import {
	hobbySkills,
	ISkillData,
	jobSkills,
	skillNames,
	sortSkills,
} from '../StatsSkillItem/StatsSkillItem.model';
import {
	StyledContainer,
	StyledSkillsCategory,
	StyledSkillsGrid,
} from './StatsSkills.styled';

const StatsSkills = () => {
	const [skillsData, setSkillsData] = useState<
		Record<CharacterSkill, ICharacterSkillLevel>
	>(() => {
		const initial: Record<CharacterSkill, ICharacterSkillLevel> = {} as any;
		[...jobSkills, ...hobbySkills].forEach((skill) => {
			initial[skill] = rage.skills.getSkillLevel(skill).getValue();
		});
		return initial;
	});

	useEffect(() => {
		const subscriptions = [...jobSkills, ...hobbySkills].map((skill) => {
			return rage.skills.getSkillLevel(skill).subscribe((data) => {
				setSkillsData((prev) => ({
					...prev,
					[skill]: data,
				}));
			});
		});

		return () => {
			subscriptions.forEach((sub) => sub.unsubscribe());
		};
	}, []);

	const sortedJobSkills = useMemo(() => {
		const skills: ISkillData[] = jobSkills.map((skill) => ({
			skill,
			name: skillNames[skill],
			level: skillsData[skill]?.level ?? 1,
			maxLevel: skillsData[skill]?.maxLevel ?? 1,
			exp: skillsData[skill]?.exp ?? 0,
			maxExp: skillsData[skill]?.maxExp ?? 0,
		}));
		return sortSkills(skills);
	}, [skillsData]);

	const sortedHobbySkills = useMemo(() => {
		const skills: ISkillData[] = hobbySkills.map((skill) => ({
			skill,
			name: skillNames[skill],
			level: skillsData[skill]?.level ?? 1,
			maxLevel: skillsData[skill]?.maxLevel ?? 1,
			exp: skillsData[skill]?.exp ?? 0,
			maxExp: skillsData[skill]?.maxExp ?? 0,
		}));
		return sortSkills(skills);
	}, [skillsData]);

	return (
		<StyledContainer tabIndex={-1}>
			<StyledSkillsCategory>
				<Text>— Рабочие навыки</Text>
				<StyledSkillsGrid>
					{sortedJobSkills.map((skillData) => (
						<StatsSkillItem
							name={skillData.name}
							skill={skillData.skill}
							level={skillData.level}
							current={skillData.exp}
							target={skillData.maxExp}
							isMaxLevel={skillData.level === skillData.maxLevel}
							key={skillData.skill}
						/>
					))}
				</StyledSkillsGrid>
			</StyledSkillsCategory>
			{sortedHobbySkills.length > 0 && (
				<StyledSkillsCategory>
					<Text>— Хобби</Text>
					<StyledSkillsGrid>
						{sortedHobbySkills.map((skillData) => (
							<StatsSkillItem
								name={skillData.name}
								skill={skillData.skill}
								level={skillData.level}
								current={skillData.exp}
								target={skillData.maxExp}
								isMaxLevel={skillData.level === skillData.maxLevel}
								key={skillData.skill}
							/>
						))}
					</StyledSkillsGrid>
				</StyledSkillsCategory>
			)}
		</StyledContainer>
	);
};

export { StatsSkills };
